import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Track Activity
 */
type IParams = {
  personalizedLink?: string
  isClicked?: boolean
  user?: string
  marketingUserId?: string
  campaignId?: string
}

const trackActivity = (data: IParams): Promise<void> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.MARKETING + '/track-activity'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const newData: IParams = {}
    if (data.personalizedLink) {
      newData.personalizedLink = data.personalizedLink
    }
    if (data.isClicked) {
      newData.isClicked = data.isClicked
    }
    if (data.user) {
      newData.user = data.user
    }
    if (data.marketingUserId) {
      newData.marketingUserId = data.marketingUserId
    }
    if (data.campaignId) {
      newData.campaignId = data.campaignId
    }
    AxiosClient.post(URL, newData, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default trackActivity
